'use client'

import { convertMultilingualData } from '@/lib/translation/multilingual'
import { DEFAULT_LANGUAGE } from '@/lib/translation/utils'
import { FooterProps } from '@/lib/types/footerProps'
import dynamic from 'next/dynamic'

const DynamicFooter = dynamic(() => import('./DynamicFooter'), {
  ssr: false,
  loading: () => null
})

export function DynamicFooterWrapper(props: Readonly<FooterProps>) {
  const { lang = DEFAULT_LANGUAGE, data, ...rest } = props

  const convertedData = convertMultilingualData(data, lang)

  const enhancedData = {
    ...convertedData,
    language: lang
  }

  return <DynamicFooter {...rest} data={enhancedData} lang={lang} />
}
